import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface MarkLostDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  pending?: boolean;
  onSubmit: (reason: string) => void;
}

/** Tapt arkiveres med årsak. Årsaken er påkrevd. */
export default function MarkLostDialog({ open, onOpenChange, title, pending, onSubmit }: MarkLostDialogProps) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (open) setReason("");
  }, [open]);
  const valid = reason.trim().length > 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Marker som tapt</DialogTitle>
          <DialogDescription>«{title}» flyttes til avsluttede prosesser med årsaken du skriver.</DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (valid) onSubmit(reason.trim());
          }}
        >
          <div className="space-y-1.5 py-2">
            <Label htmlFor="lost-reason">Årsak</Label>
            <Textarea id="lost-reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={4} autoFocus />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Avbryt
            </Button>
            <Button type="submit" disabled={!valid || pending}>
              {pending ? "Lagrer ..." : "Marker som tapt"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
